import { useCallback, useEffect, useState } from "react";
import {
  firmasElectronicas,
  getUserData,
  ValorServiceFirmaElectronica,
} from "../../legal/Content";

export function ContractFirmaElectronicaV3({
  basicInfo,
  userinfo,
  creditUser,
  firmaElectronica,
  dctoFirmaElectronica,
  total,
}) {
  const [, setUserData] = useState([]);

  const handleUserData = useCallback(() => {
    let userData = getUserData(basicInfo, userinfo);
    setUserData(userData);
  }, [basicInfo, userinfo]);

  useEffect(() => {
    handleUserData();
  }, [creditUser, basicInfo, userinfo, handleUserData]);

  return (
    <>
      <div className="text-sm py-8 px-4">
        <div className="text-center w-full font-bold2">
          <div className="w-full">
            <div>CONTRATO DE FIRMA ELECTRÓNICA EN LA NUBE</div>
          </div>
        </div>
        <div className="pt-4">
          <span className="font-semibold2">
            El servicio de Firma Electrónica permite a los usuarios firmar
            documentos de manera segura, rápida y con plena validez jurídica en
            Colombia, conforme a lo dispuesto en la Ley 527 de 1999, el Decreto
            2364 de 2012 y el artículo 244 del Código General del Proceso. La
            autenticación se realiza mediante el envío de un Código OTP (One
            Time Password) de seis dígitos, generado de forma única y enviado al
            correo electrónico y/o celular registrado por el usuario,
            garantizando la identificación, integridad y no repudio de la firma.
          </span>
        </div>
        <div className="pt-4">
          <span className="font-bold2">Objeto:</span>
        </div>
        <div className="pt-4 mb-4">
          <span className="font-semibold2">
            El Proveedor prestará al Cliente el servicio de Firma Electrónica en
            la nube, a través de un sistema seguro que envía un código único de
            verificación (OTP) al correo electrónico y/o celular registrado por
            el Cliente. Este servicio permite al Cliente firmar documentos de
            crédito de manera remota, con plena validez jurídica en Colombia.
          </span>
        </div>
        <div className="mb-4 p-3 bg-yellow-50 border-l-4 border-yellow-400">
          <p className="text-justify font-bold2">
            IMPORTANTE: La adquisición del servicio de Firma Electrónica no
            condiciona la solicitud, aprobación o desembolso del crédito entre
            el Usuario y Galilea, en el entendido que son dos objetos
            contractuales diferentes.
          </p>
        </div>
        <div className="pt-4">
          <span className="font-bold2">Partes y valor del servicio:</span>
        </div>

        {ValorServiceFirmaElectronica.map((valorService, index) => (
          <ul key={index} className="marker:text-white list-disc">
            <div key={index} className="pl-4 grid grid-cols-5">
              <div className="col-span-2 font-bold2">
                <li>{valorService.title}</li>
              </div>
              <div className="col-span-3 ml-2">
                {valorService.title === "Contratante:" ? (
                  <span>
                    {basicInfo.userName || "___________________________"}
                  </span>
                ) : (
                  <span className="font-semibold2">{valorService.value}</span>
                )}
              </div>
            </div>
          </ul>
        ))}

        <div class="pt-4">
          <span class="font-bold2">Ejecución del servicio:</span>
        </div>

        <div class="mt-4 overflow-x-auto mb-4">
          <table class="w-full border border-purple-300 text-sm">
            <thead class="bg-purple-200 text-left">
              <tr>
                <th class="border border-purple-300 px-3 py-2 font-bold2 w-20">
                  Acción
                </th>
                <th class="border border-purple-300 px-3 py-2 font-bold2">
                  Descripción
                </th>
              </tr>
            </thead>

            <tbody class="bg-purple-50">
              <tr>
                <td class="border border-purple-300 px-3 py-2 font-semibold2">
                  Primera:
                </td>
                <td class="border border-purple-300 px-3 py-2 text-justify font-semibold2">
                  El Usuario podrá acceder al servicio desde cualquier
                  dispositivo conectado a la red de internet.
                </td>
              </tr>

              <tr>
                <td class="border border-purple-300 px-3 py-2 font-semibold2">
                  Segunda:
                </td>
                <td class="border border-purple-300 px-3 py-2 text-justify font-semibold2">
                  El servicio se ejecutará desde la nube y haciendo uso de la
                  Plataforma de solicitud y aprobación del crédito desarrollada
                  por Galilea. La adquisición del servicio de Firma Electrónica
                  no condiciona la solicitud, aprobación o desembolso del
                  crédito entre el Usuario y Galilea al ser dos objetos
                  contractuales diferentes.
                </td>
              </tr>

              <tr>
                <td class="border border-purple-300 px-3 py-2 font-semibold2">
                  Tercera:
                </td>
                <td class="border border-purple-300 px-3 py-2 text-justify font-semibold2">
                  El Usuario recibirá un Código OTP (One Time Password) a su
                  correo electrónico y número de teléfono vinculado a WhatsApp.
                  Este código podrá ser de 6 dígitos. Una vez recibido el código
                  por el Usuario este debe incorporarlo en el apartado indicado
                  en la Plataforma del Originador del Crédito.
                </td>
              </tr>

              <tr>
                <td class="border border-purple-300 px-3 py-2 font-semibold2">
                  Cuarta:
                </td>
                <td class="border border-purple-300 px-3 py-2 text-justify font-semibold2">
                  Si hay coincidencia entre el código enviado y el digitado por
                  el Usuario, el contrato y documentos del crédito quedarán
                  firmados electrónicamente.
                </td>
              </tr>

              <tr>
                <td class="border border-purple-300 px-3 py-2 font-semibold2">
                  Quinta:
                </td>
                <td class="border border-purple-300 px-3 py-2 text-justify font-semibold2">
                  Los documentos serán enviados al correo electrónico registrado
                  por el Usuario, así mismo, estarán disponibles para posterior
                  consulta de cuando lo indique y Galilea guardará y custodiará
                  los documentos originales cuidando la respectiva integridad,
                  autenticidad, no repudio, consentimiento, conservación y
                  acceso.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="pt-2">
          <span className="font-bold2">Término:</span>
        </div>
        <div className="mb-4">
          <p className="text-justify font-semibold2">
            El servicio de Firma Electrónica en la nube es de ejecución
            instantánea: se considera prestado en el momento en que el Usuario
            introduce el Código OTP y se firma el documento correspondiente. En
            consecuencia, no se encuentra sujeto a renovación, prórroga o
            terminación posterior.
          </p>
        </div>

        <div className="pt-2">
          <span className="font-bold2">Aceptación:</span>
        </div>
        <div className="mb-4">
          <p className="text-justify">
            El Usuario manifiesta su aceptación inicial mediante clic en el
            checkbox dispuesto por Galilea antes de firmar electrónicamente los
            documentos. La manifestación indicada a través del Checkbox se
            materializa con la incorporación del Código OTP enviado por medio
            del cual se tiene plena aceptación de optar por el servicios de
            Firma Electrónica. Esta acción genera la plena validez del contrato
            y el nacimiento de las obligaciones derivadas del mismo. Dicha
            aceptación equivale a la firma manuscrita del Usuario conforme a los
            artículos 7 y 8 de la Ley 527 de 1999 y a lo dispuesto por el
            Decreto 2364 de 2012.
          </p>
        </div>

        <div className="pt-4">
          <span className="font-bold2">Garantías y ANS:</span>
        </div>
        <div className="mb-4">
          <p className="text-justify">
            Galilea garantiza que el servicio será prestado con estándares
            técnicos adecuados, utilizando medidas de seguridad razonables para
            proteger la autenticidad e integridad de las firmas y documentos.
            Asimismo, declara contar con{" "}
            <span className="font-bold2">
              acuerdos de niveles de servicio (ANS){" "}
            </span>
            que garantizan disponibilidad y continuidad del servicio.
          </p>
          <p className="text-justify mt-2">
            Las partes declaran que los recursos involucrados en la ejecución
            del contrato no provienen de actividades ilícitas y que cumplen las
            normas de prevención de lavado de activos y financiación del
            terrorismo (LA/FT).
          </p>
        </div>

        <div className="pt-4">
          <span className="font-bold2">Protección de Datos Personales:</span>
        </div>

        <div class="mt-4 overflow-x-auto mb-4">
          <table class="w-full border border-purple-300 text-sm">
            <thead class="bg-purple-200 text-left">
              <tr>
                <th class="border border-purple-300 px-3 py-2 font-bold2">
                  Finalidades:
                </th>
              </tr>
            </thead>

            <tbody class="bg-purple-50">
              <tr>
                <td class="border border-purple-300 px-3 py-2 text-justify font-semibold2">
                  Prestar los servicios contratados.
                </td>
              </tr>

              <tr>
                <td class="border border-purple-300 px-3 py-2 text-justify font-semibold2">
                  Cumplir obligaciones legales y contractuales.
                </td>
              </tr>

              <tr>
                <td class="border border-purple-300 px-3 py-2 text-justify font-semibold2">
                  Realizar validaciones de identidad y autenticación.
                </td>
              </tr>

              <tr>
                <td class="border border-purple-300 px-3 py-2 text-justify font-semibold2">
                  Enviar comunicaciones relacionadas con el servicio de firma
                  electronica.
                </td>
              </tr>

              <tr>
                <td class="border border-purple-300 px-3 py-2 text-justify font-semibold2">
                  Compartir información con proveedores de tecnológicos y
                  aliados estrategicos.
                </td>
              </tr>

              <tr>
                <td class="border border-purple-300 px-3 py-2 text-justify font-semibold2">
                  El usuario podrá ejercer sus derechos de acceso, notificación,
                  supresión o revocatoria conforme a las politicas de
                  tratamiento de datos personales disponibles en{" "}
                  <a
                    href="https://galilea.co"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#9592ff", textDecoration: "underline" }}
                  >
                    www.galilea.co
                  </a>{" "}
                  comunicandose al correo electronico ayuda@galilea.co.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="pt-4">
          <span className="font-bold2">Disposiciones generales:</span>
        </div>
        <div className="mb-4 pl-4">
          <p className="text-justify mb-2">
            <span className="font-bold2">a) Cesión:</span> Galilea podrá ceder
            los derechos y obligaciones derivados del presente contrato sin
            requerir autorización del Usuario.
          </p>
          <p className="text-justify mb-2">
            <span className="font-bold2">b) Modificaciones:</span> Toda
            modificación al contrato deberá constar por escrito o en formato
            electrónico aceptado por ambas partes.
          </p>
          <p className="text-justify mb-2">
            <span className="font-bold2">c) Integridad:</span> Este contrato
            contiene la totalidad del acuerdo entre las partes y reemplaza
            cualquier comunicación o acuerdo previo.
          </p>
          <p className="text-justify mb-2">
            <span className="font-bold2">d) Ley aplicable:</span> Se regirá por
            las leyes de la República de Colombia.
          </p>
          <p className="text-justify mb-2">
            <span className="font-bold2">e) Evidencia electrónica:</span> Los
            registros electrónicos generados por Galilea constituirán plena
            prueba de la aceptación, ejecución y cumplimiento del contrato.
          </p>
        </div>

        <div>
          <div className="mt-4">
            <div>
              <h2 className="font-bold">Firma Electrónica</h2>
            </div>
            <div className="mt-4">
              {firmasElectronicas.map((firmaE, idx) => (
                <ul key={idx} className="grid grid-cols-5">
                  <div className="col-span-2">
                    <li>{firmaE.title}</li>
                  </div>
                  <div className="col-span-3 ml-2">
                    <span> {firmaE.value} </span>
                  </div>
                </ul>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
